// The latest road map (render/roadMap), published for readers that are not the
// street lights — the radar draws its road layer from it. Subscribers are
// called once per new map.
const subs = new Set();

export const roadMapBridge = {
  map: null,
  publish(map) {
    this.map = map;
    if (typeof window !== 'undefined' && window.__look) window.__look.roadMap = map;   // dev handle
    subs.forEach((fn) => { try { fn(map); } catch (e) { console.warn('[roadmap] subscriber failed', e); } });
  },
  subscribe(fn) {
    subs.add(fn);
    if (this.map) fn(this.map);
    return () => subs.delete(fn);
  },
};
